module.exports = __webpack_public_path__ + "img/hand-right-off.b2a0d0b0.png";